import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';

@NgModule({
  exports: [ScrollingModule, DragDropModule],
})
export class MaterialModule {}
